import { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
// Material Dashboard 2 React components
import { Button } from '@mui/material';
import MDBox from "components/MDBox";
import { AuthContext } from "context";
import { createMRTColumnHelper } from 'material-react-table';
import toast from 'react-hot-toast';
import MDTypography from "../../components/MDTypography";
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";
import apiService from "../../services/api-service";
import GenericTable from "../genericTable.js";

function UserExternalManagment() {

      const authContext = useContext(AuthContext);
      const [aree, setAree] = useState([]);
      const [areaSelect,setAreaSelect] = useState(localStorage.getItem("areaSelected"));
      const [showSideBar,setShowSideBar] = useState(false);
      const navigate = useNavigate();
      const location = useLocation();
      const [data, setData] = useState([])

      function fetchData(){
           apiService.get('/user-external-management/', { }, {})
              .then(data => {
                setData(data);
              })
              .catch(error => toast.error("Errore durante il caricamento dei dati. Riprova più tardi se l'errore persiste contatti il supoorto tecnico indicato l'errore #00030", {id: 'user-external-managment-toast'}));
      }

      useEffect(() => {
         fetchData()
      }, [])

      const columnHelper = createMRTColumnHelper();

      const handleEdit = (id) => {
        navigate(`edit/${id}`);
      };

      async function deleteResource(id) {
          try {
            // Costruisci l'endpoint usando l'id fornito
            const endpoint = `/user-external-management/`;

            // Parametri opzionali per la richiesta DELETE
            const params = {id:id}; // Puoi aggiungere parametri se necessario
            const headers = {}; // Headers opzionali

            // Esegui la chiamata DELETE
            const response = await apiService.delete(endpoint, params, headers);

            // Se arriviamo qui, la chiamata è andata a buon fine
            console.log(`Risorsa con id ${id} eliminata con successo:`, response);

            // Puoi fare qualcosa con la risposta, se necessario
            return response;

          } catch (error) {
            // Gestisci eventuali errori
            console.error(`Errore durante l'eliminazione della risorsa con id ${id}:`, error.message);

            // Puoi gestire l'errore in modo specifico, ad esempio:
            if (error.message.includes('404')) {
              console.log(`La risorsa con id ${id} non è stata trovata`);
            } else if (error.message.includes('403')) {
              console.log(`Non hai i permessi per eliminare la risorsa con id ${id}`);
            }

            // Rilancia l'errore se vuoi che venga gestito a un livello superiore
            throw error;
          }
        }

      function handleDelete(id) {
          if(window.confirm("Sei sicuro di voler eliminare questo utente?\n Attenzione questa operazione è irreversibile.")) {
          deleteResource(id)
              .then(result => {
                  toast.success("Utente eliminato con successo", {id: 'user-external-managment-toast'})
                  fetchData()
              })
              .catch(error => {
                  toast.error("Si è verificato un errore durante l'eliminazione del utente. Riprova più tardi se l'errore persiste contatta il supporto tecnico indicato l'errore #00032", {id: 'user-external-managment-toast'})
              });
          }
      }

      let columns;
      // Determina se è admin (vede tutti i fornitori) o fornitore (vede solo i suoi)
      const isAdmin = authContext.hasAuth("VIEW_EXTERNAL_USER_ADMIN") || authContext.hasAuth("VIEW_EXTERNAL_USER");
      
      if (isAdmin) {
        columns = [
          columnHelper.accessor('supplier', {
            header: 'Fornitore',
            size: 120,
          }),
          columnHelper.accessor('first_name', {
            header: 'Nome',
            size: 120,
          }),
          columnHelper.accessor('last_name', {
            header: 'Cognome',
            size: 120,
          }),
          columnHelper.accessor('fiscal_code', {
            header: 'Codice fiscale',
            size: 120,
          }),
          columnHelper.accessor('date_of_birth', {
            header: 'Data di nascita',
            size: 120,
          }),
        ];
      }
      else {
        columns = [
          columnHelper.accessor('first_name', {
            header: 'Nome',
            size: 120,
          }),
          columnHelper.accessor('last_name', {
            header: 'Cognome',
            size: 120,
          }),
          columnHelper.accessor('phone', {
            header: 'Telefono',
            size: 120,
          }),
          columnHelper.accessor('fiscal_code', {
            header: 'Codice fiscale',
            size: 120,
          }),
          columnHelper.accessor('date_of_birth', {
            header: 'Data di nascita',
            size: 120,
          }),
          columnHelper.accessor('is_admin', {
            header: 'Ruolo',
            size: 100,
            Cell: ({ cell }) => cell.getValue() ? 'Admin' : 'Dipendente',
          }),
        ];
      }

      return (
          <>
        <DashboardLayout>
          <DashboardNavbar />
          <MDBox pt={6} pb={3}>
            <MDTypography variant="h6" color="black">
              OPERATORI ESTERNI
            </MDTypography>
            { (authContext.hasAuth("ADD_EXTERNAL_USER") || authContext.hasAuth("ADD_SUPPLIER_EMPLOYEES")) &&
              <Button
              variant="contained"
              color="primary"
              onClick={() => navigate("add")}
              sx={{mt: 2, alignSelf: 'center', minWidth: '100px', color: "#ffffff"}}
              >
                AGGIUNGI
              </Button>
            }
          </MDBox>
          {(() => {
            if (authContext.hasAuth("VIEW_SUPPLIER_EMPLOYEES")) {
              return <GenericTable authModelName={"SUPPLIER_EMPLOYEES"} data={data} columns={columns} onDelete={handleDelete} onEdit={handleEdit}/>;
            } else if (authContext.hasAuth("VIEW_EXTERNAL_USER_ADMIN")) {
              return <GenericTable authModelName={"EXTERNAL_USER_ADMIN"} data={data} columns={columns} onDelete={handleDelete} onEdit={handleEdit}/>;
            } else if (authContext.hasAuth("VIEW_EXTERNAL_USER")) {
              return <GenericTable authModelName={"EXTERNAL_USER"} data={data} columns={columns} onDelete={handleDelete} onEdit={handleEdit}/>;
            }
            return null;
          })()}
          </DashboardLayout>
          </>
      );
    }

export default UserExternalManagment;
